import { CREATIVE_VAST_ACTIONS } from "reducers/actions/Creatives";
import { downloadFile } from "reducers/Download";
import { SUPPRESS_ERROR_GROWL, SUPPRESS_SUCCESS_GROWL, API_URL } from "utils/constants";

export const YOUTUBE_IMPORT_JOB_STATUS = {
	STARTED:1,
	FINISHED:2,
	FAILED:3,
	CANCELED:4,
};

const TERMINAL_YOUTUBE_IMPORT_JOB_STATUSES = [
	YOUTUBE_IMPORT_JOB_STATUS.FINISHED,
	YOUTUBE_IMPORT_JOB_STATUS.FAILED,
	YOUTUBE_IMPORT_JOB_STATUS.CANCELED,
];

export const YOUTUBE_IMPORT_JOB_POLL_INTERVAL_MS = 2000;
export const YOUTUBE_IMPORT_JOB_MAX_POLL_ATTEMPTS = 60;

export function createYoutubeUrlCreative(libraryId, { name, youtubeUrl }){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_AJAX,
			AJAX:{
				url:`creative-libraries/${libraryId}/youtube-creatives`,
				method:"post",
				data:{ name, youtubeUrl },
				success:CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_ERROR,
			},
			meta:{ ...SUPPRESS_SUCCESS_GROWL, ...SUPPRESS_ERROR_GROWL },
		});
	};
}

export function exportYoutubeUrlTemplate(libraryId){
	return (dispatch) => {
		const url = `${API_URL}/crm/v1/creative-libraries/${libraryId}/youtube-creatives/export-template`;
		return dispatch(downloadFile(url));
	};
}

export function importYoutubeUrlCreatives(libraryId, formData){
	return (dispatch) => {
		return dispatch({
			type:CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_AJAX,
			AJAX:{
				url:`creative-libraries/${libraryId}/youtube-creatives/import`,
				method:"post",
				data:formData,
				success:CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_SUCCESS,
				error:CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_ERROR,
			},
			meta:{ ...SUPPRESS_SUCCESS_GROWL, ...SUPPRESS_ERROR_GROWL },
		});
	};
}

export function pollYoutubeImportJob(jobId){
	return (dispatch) => {
		function poll(attempt = 1){
			return dispatch({
				type:CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_AJAX,
				AJAX:{
					url:`jobs/${jobId}`,
					success:CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_SUCCESS,
					error:CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_ERROR,
				},
				meta:{ ...SUPPRESS_SUCCESS_GROWL, ...SUPPRESS_ERROR_GROWL },
			}).then((resp) => {
				if(!resp?.success){ return resp; }

				const status = resp.payload?.data?.status;
				if(TERMINAL_YOUTUBE_IMPORT_JOB_STATUSES.includes(status)){ return resp; }
				if(attempt >= YOUTUBE_IMPORT_JOB_MAX_POLL_ATTEMPTS){
					dispatch({ type:CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_TIMEOUT });
					return { ...resp, timedOut:true };
				}

				return new Promise((resolve) => {
					setTimeout(() => resolve(poll(attempt + 1)), YOUTUBE_IMPORT_JOB_POLL_INTERVAL_MS);
				});
			});
		}

		return poll();
	};
}

function isSavingYoutubeUrlCreative(state, action){
	return {
		...state,
		isSavingYoutubeUrlCreative:true,
		youtubeUrlError:null,
	};
}

function isSavingYoutubeUrlCreativeSuccess(state, action){
	return {
		...state,
		isSavingYoutubeUrlCreative:false,
		youtubeUrlError:null,
		items:[action.payload.data, ...state.items],
	};
}

function isSavingYoutubeUrlCreativeError(state, action){
	return {
		...state,
		isSavingYoutubeUrlCreative:false,
		youtubeUrlError:action.payload.errorObj,
	};
}

function isImportingYoutubeUrlCreatives(state, action){
	return {
		...state,
		isImportingYoutubeUrlCreatives:true,
		youtubeImportJob:null,
	};
}

function isImportingYoutubeUrlCreativesSuccess(state, action){
	return {
		...state,
		youtubeImportJob:action.payload.data,
	};
}

function isImportingYoutubeUrlCreativesError(state, action){
	return {
		...state,
		isImportingYoutubeUrlCreatives:false,
		youtubeImportJob:null,
		youtubeImportError:action.payload.errorObj,
	};
}

function isPollingYoutubeImportJobSuccess(state, action){
	const job = action.payload.data
		, isTerminal = TERMINAL_YOUTUBE_IMPORT_JOB_STATUSES.includes(job.status)
		;

	return {
		...state,
		isImportingYoutubeUrlCreatives:!isTerminal,
		youtubeImportJob:job,
	};
}

function isPollingYoutubeImportJobError(state, action){
	return {
		...state,
		isImportingYoutubeUrlCreatives:false,
		youtubeImportError:action.payload.errorObj,
	};
}

function isPollingYoutubeImportJobTimeout(state, action){
	return {
		...state,
		isImportingYoutubeUrlCreatives:false,
	};
}

export const HANDLERS = {
	[CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_AJAX]:isSavingYoutubeUrlCreative,
	[CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_SUCCESS]:isSavingYoutubeUrlCreativeSuccess,
	[CREATIVE_VAST_ACTIONS.CREATE_YOUTUBE_URL_CREATIVE_ERROR]:isSavingYoutubeUrlCreativeError,

	[CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_AJAX]:isImportingYoutubeUrlCreatives,
	[CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_SUCCESS]:isImportingYoutubeUrlCreativesSuccess,
	[CREATIVE_VAST_ACTIONS.IMPORT_YOUTUBE_URL_CREATIVES_ERROR]:isImportingYoutubeUrlCreativesError,

	[CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_SUCCESS]:isPollingYoutubeImportJobSuccess,
	[CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_ERROR]:isPollingYoutubeImportJobError,
	[CREATIVE_VAST_ACTIONS.POLL_YOUTUBE_IMPORT_JOB_TIMEOUT]:isPollingYoutubeImportJobTimeout,
};

export const PRIVATE = {
	isSavingYoutubeUrlCreative,
	isSavingYoutubeUrlCreativeSuccess,
	isSavingYoutubeUrlCreativeError,
	isImportingYoutubeUrlCreatives,
	isImportingYoutubeUrlCreativesSuccess,
	isImportingYoutubeUrlCreativesError,
	isPollingYoutubeImportJobSuccess,
	isPollingYoutubeImportJobError,
	isPollingYoutubeImportJobTimeout,
};
